angular.module('unergie.main')
.controller('siretsCtrl', ($scope, BoFeaturesService, AlertManager, TableGeneratorService, ApiUser, ApiAdmin, DataAccess, ModalService, ErrorCatcher) => {
    $scope.notNullFilter = [{ id: '!<null>', title: 'Oui' }, { id: '<null>', title: 'Non' }]

    $scope.sirets = {
        refreshing: false,
        show: {},
        columns: {
            id: { label: 'SIRET', mode: 'search_wildcard', mandatory: true },
            status: { label: 'Statut', mode: 'search_wildcard' },
            legal_name: { label: 'Raison sociale', mode: 'search_wildcard' },
            business_line: { label: `Secteur d'activité`, mode: 'search_wildcard' },
            business_code: { label: 'NAF', mode: 'search_wildcard' },
            legal_category: { label: 'Catégorie juridique', mode: 'search_wildcard' },
            hq_addr_num_street: { label: 'Adresse', mode: 'search_wildcard' },
            hq_addr_post_code: { label: 'Code postal', mode: 'search_wildcard' },
            hq_addr_city_lbl: { label: 'Ville', mode: 'search_wildcard' },
            treasury_name: { label: 'Nom tréso.', mode: 'search_wildcard' },
            mandatary_mail: { label: 'Email mandataire', mode: 'search_wildcard' },
            accounting_mail: { label: 'Email comptabilité', mode: 'search_wildcard' },
            source: { label: 'Source validation', mode: 'search_wildcard' },
            odoo_id: { label: 'Odoo', mode: 'search_wildcard' },
            odoo_error: { label: 'Erreur Odoo', mode: 'search_wildcard' },
            creation_ts: { label: 'Date création', mode: 'search_date' },
        },
    }

    $scope.refresh = () => TableGeneratorService.getTable($scope.sirets, 'sirets', null, null, { orderBy: 'id' })

    $scope.updateSiretFields = {
        legal_name: { label: `Raison sociale`, type: 'text' },
        business_line: { label: `Secteur d'activité`, type: 'text' },
        business_code: { label: `NAF`, type: 'text' },
        hq_addr_num_street: { label: `Adresse`, type: 'text' },
        hq_addr_post_code: { label: `Code postal`, type: 'text', pattern: /\d{5}/ },
        hq_addr_city_lbl: { label: `Ville`, type: 'text', forceUppercase: true },
        treasury_name: { label: `Nom tréso.`, type: 'text' },
        mandatary_mail: { label: `Email mandataire`, type: 'email' },
        accounting_mail: { label: `Email comptabilité`, type: 'email' },
    }

    $scope.updateSiretTemplate = {}

    const newSiretTemplate = {}

    $scope.newSiretTemplate = _.clone(newSiretTemplate)
    $scope.newSiretFields = {
        siret: { label: `SIRET`, type: 'text', required: true, pattern: /\d{14}/ },
    }

    $scope.fillSiretTemplate = (siret) => {
        _.assign($scope.updateSiretTemplate, _.pick(siret, _.keys($scope.updateSiretFields)))
    }

    $scope.newSiret = (siret) => {
        const payload = {}
        if (siret) {
            siret.resyncing = true
            payload.siret = siret.id
        } else {
            $scope.creating = true
            payload.siret = $scope.newSiretTemplate.siret
        }
        return ApiUser.createOrUpdateSiret(payload).$promise
        .then((result) => {
            if (siret) {
                AlertManager.success(`${siret.id} mis à jour via ${result.source}`)
            } else {
                AlertManager.success(`SIRET créé`)
                $scope.newSiretTemplate = _.clone(newSiretTemplate)
            }
        })
        .catch(ErrorCatcher)
        .finally(() => {
            if (siret) {
                siret.resyncing = false
            } else {
                $scope.creating = false
            }
            $scope.refresh()
        })
    }

    $scope.resyncSiret = (siret) => $scope.newSiret(siret)


    $scope.updateSiret = (siret) => {
        siret.updating = true
        return DataAccess.updateSiret({ id: siret.id }, _.pickBy($scope.updateSiretTemplate)).$promise
        .then((result) => {
            AlertManager.success(`SIRET mis à jour`)
            $scope.refresh()
        })
        .catch(ErrorCatcher)
        .finally(() => {
            siret.updating = false
        })
    }

    $scope.updateSiretStatusFields = {
        status: {
            label: `Nouveau statut`,
            type: 'select',
            required: true,
            enum: [
                { value: 'ACTIVE', label: 'ACTIVE' },
                { value: 'CLOSED', label: 'CLOSED' },
                { value: 'UNCHECKED', label: 'UNCHECKED' },
                { value: 'NOT_FOUND', label: 'NOT_FOUND' },
                { value: 'INACTIVE', label: 'INACTIVE' },
            ],
        },
    }

    $scope.updateSiretStatusTemplate = {}

    $scope.fillSiretStatusTemplate = (siret) => {
        _.assign($scope.updateSiretStatusTemplate, { status: siret.status })
    }

    $scope.updateSiretStatus = (siret) => {
        siret.updating = true
        return DataAccess.updateSiretStatus({ id: siret.id, status: $scope.updateSiretStatusTemplate.status }, {}).$promise
        .then((result) => {
            AlertManager.success(`Statut du SIRET mis à jour`)
            $scope.refresh()
        })
        .catch(ErrorCatcher)
        .finally(() => {
            siret.updating = false
        })
    }

    $scope.synchSiretsWithOdoo = (siretsParam) => {
        const sirets = _.castArray(siretsParam)
        _.each(sirets, (siret) => (siret.synchingWithOdoo = true))
        return ApiAdmin.synchSiretsWithOdoo({ limit: (sirets.length * 2) + 10, ids: _.map(sirets, 'id') }).$promise
        .then((result) => {
            AlertManager.success(`SIRETs mis à jour dans Odoo`)
            ModalService.openModal({ type: 'resultModal', size: 'lg' }, { result }, () => {
                $scope.refresh()
            })
        })
        .catch(ErrorCatcher)
        .finally(() => {
            _.each(sirets, (siret) => (siret.synchingWithOdoo = false))
        })
    }

    $scope.refresh()
})
